import { MapDateRange } from '@common-modules/wlm-map/models/map-date-range';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { LayerItemV2 } from '../models/layer-item';
import { IMapFiltrableProperties } from '../models/map-filtrable-properties';
import { MapGenericStyle } from '../models/map-generic-style';
import { MapAdditionalAttributes } from '../models/map-results';
import { MapTooltipParams } from '../models/map-tooltip-params';
import { NativeLayer } from '../models/native-layer';
import { GenericMapStylesService } from './generic-map-styles.service';

export type TMapResult = any;

export abstract class BaseLayerItemService {
  abstract type: string;

  constructor(protected readonly _mapStylesService: GenericMapStylesService) {}

  abstract getFilters(properties: IMapFiltrableProperties): CompositeFilterDescriptor;
  abstract getResults(properties: IMapFiltrableProperties, timeStep: Date): Observable<TMapResult>;
  abstract getInnerLayerAttributes(
    innerLayer: NativeLayer,
    attributes: MapAdditionalAttributes,
    timeStep: Date
  ): Map<string, any>;
  abstract formatAttributes(
    attributes: Map<string, any>,
    innerLayer: NativeLayer
  ): Observable<Map<string, string>>;
  abstract getTooltip(params: MapTooltipParams): Observable<HTMLElement>;
  abstract getDateRange(params): Observable<MapDateRange>;
  abstract getElementAdditionalProperties(
    innerLayer: NativeLayer,
    attributes: MapAdditionalAttributes
  ): Map<string, any>;
  abstract getLabelPropertiesMap(nativeLayer: NativeLayer): Observable<Map<string, any>>;

  abstract hasLayerId(nativeLayer: NativeLayer, layerId: string): boolean;
  abstract persistLayerVisibility(layerItem: LayerItemV2, isVisible: boolean): void;
  abstract persistLayersOrder(layerItems: LayerItemV2[]): void;
  abstract getInnerLayerId(nativeLayer: NativeLayer): string;

  getStyles(layerItem: LayerItemV2, isUpdate?: boolean): Observable<MapGenericStyle> {
    if (layerItem.layerDefinition?.isThematic === true && layerItem.layerStyle) {
      if (!layerItem.availableStyles) {
        layerItem.availableStyles = [];
      }

      const existingStyleIndex = layerItem.availableStyles.findIndex(
        (style) =>
          style.id === layerItem.layerStyle.id ||
          JSON.stringify(style) === JSON.stringify(layerItem.layerStyle)
      );

      if (existingStyleIndex !== -1) {
        const [existingStyle] = layerItem.availableStyles.splice(existingStyleIndex, 1);
        layerItem.availableStyles.unshift(existingStyle);
      } else {
        layerItem.availableStyles.unshift(layerItem.layerStyle);
      }
    }
    const style =
      layerItem.layerStyle ??
      (layerItem.availableStyles && layerItem.availableStyles.length > 0
        ? layerItem.availableStyles[0]
        : null);

    return of(style);
  }
}
